import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/activeProject/user.activeProject.mutation.gql"
import type {
  UserActiveProjectMutation,
  UserActiveProjectMutationVariables,
} from "@/v2-backoffice-client/user/activeProject/__types__/user.activeProject.mutation"

type Options = MutationHookOptions<
  UserActiveProjectMutation,
  UserActiveProjectMutationVariables
>

export function useUserActiveProjectMutation(options?: Options) {
  return useMutation<
    UserActiveProjectMutation,
    UserActiveProjectMutationVariables
  >(mutation, options)
}
